import React, { useState, useEffect } from 'react'
import BasicPagination from '../Pagination';
import { GET_WITH_TOKEN } from '../../Backend/Bakend';
import { showToast } from '../Constent/Toast';

const Inquiries = () => {
    const [inquiriesData, setInquiriesData] = useState([]);
    const [totalPage, setTotalPage] = useState(0);
    const [CurrentPage, setCurrentPage] = useState(1);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(false);
    const [selectedInquiry, setSelectedInquiry] = useState(null);

    useEffect(() => {
        getInquiries(1);
    }, []);

    const getInquiries = (page) => {
        setLoading(true);
        setInquiriesData([]);
        GET_WITH_TOKEN(`/api/inquiries?page=${page}&search=${search}`, "", 
            success => {
                setLoading(false);
                if (success?.data?.data) {
                    setInquiriesData(success.data.data);
                    setTotalPage(success.data.last_page);
                    setCurrentPage(success.data.current_page);
                } else if (success?.data && Array.isArray(success.data)) {
                    setInquiriesData(success.data);
                } else if (Array.isArray(success)) {
                    setInquiriesData(success);
                }
            }, 
            error => {
                setLoading(false);
                console.log(error);
                showToast(error?.message || "Failed to fetch inquiries");
            }, 
            fail => {
                setLoading(false);
                console.log(fail);
                showToast(fail?.message || fail?.msg || "Something went wrong");
            }
        );
    };

    const handleSearch = () => {
        getInquiries(1);
    };

    const handleReset = () => {
        setSearch('');
        setTimeout(() => {
            getInquiries(1);
        }, 100);
    };

    const viewInquiryDetails = (inquiry) => {
        setSelectedInquiry(inquiry);
    };

    const getTripTypeBadge = (tripType) => {
        const typeStr = tripType != null ? String(tripType) : '';
        let badgeClass = 'bg-info';
        let displayText = typeStr || 'N/A';
        
        if (typeStr === '1') {
            displayText = 'Family Trip';
            badgeClass = 'bg-primary';
        } else if (typeStr === '2') {
            displayText = 'Solo Trip';
            badgeClass = 'bg-success';
        } else if (typeStr === '3') {
            displayText = 'Group Trip';
            badgeClass = 'bg-warning text-dark';
        } else if (typeStr === '4') {
            displayText = 'Honeymoon';
            badgeClass = 'bg-danger';
        }
        
        return <span className={`badge ${badgeClass}`}>{displayText}</span>;
    };

    return (
        <div>
            <div className='container mt-1'>
                <div className='row'>
                    <div className='col-lg-12'>
                        <div className='card'>
                            <div className='card-header'>
                                <p style={{ fontSize: '25px' }}>Inquiries</p>

                                <div className="mb-3 mt-4 d-flex">
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        placeholder="Search by Name or Mobile"
                                        style={{ width: '20%' }}
                                        value={search}
                                        onChange={(e) => setSearch(e.target.value)}
                                        onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
                                    />

                                    <button 
                                        type='button' 
                                        className='ms-4' 
                                        onClick={handleSearch}
                                        style={{ backgroundColor: '#008c93', color: '#fff', border: 'none', padding: '7px 15px', borderRadius: '8px' }}
                                    >
                                        Search
                                    </button>

                                    <button 
                                        type='button' 
                                        className='ms-2' 
                                        onClick={handleReset}
                                        style={{ backgroundColor: 'transparent', color: '#000', padding: '7px 15px', borderRadius: '8px', border: '1px solid gray' }}
                                    >
                                        Reset
                                    </button>
                                </div>
                            </div>

                            <div className='card-body' style={{ height: 550, overflowY: "scroll" }}>
                                <p style={{ fontSize: '20px' }}>View All Inquiries</p>

                                {loading ? (
                                    <div className="text-center py-5">
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                        <p className="mt-2">Loading inquiries...</p>
                                    </div>
                                ) : inquiriesData?.length > 0 ? (
                                    <table className="table table-striped table-hover">
                                        <thead>
                                            <tr>
                                                <th scope="col">#</th>
                                                <th scope="col">Name</th>
                                                <th scope="col">Mobile</th>
                                                <th scope="col">Travel From</th>
                                                <th scope="col">Trip Location</th>
                                                <th scope="col">Travellers</th>
                                                <th scope="col">Budget</th>
                                                <th scope="col">Date</th>
                                                <th scope="col">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {inquiriesData.map((inquiry, index) => (
                                                <tr key={inquiry.id || index}>
                                                    <th scope="row">{(CurrentPage - 1) * 10 + index + 1}</th>
                                                    <td>{inquiry.full_name || '-'}</td>
                                                    <td>{inquiry.mobile_no || '-'}</td>
                                                    <td>{inquiry.travel_from || '-'}</td>
                                                    <td>{inquiry.trip_location || '-'}</td>
                                                    <td>{inquiry.travellers || '-'}</td>
                                                    <td>{inquiry.budget ? `₹${inquiry.budget}` : '-'}</td>
                                                    <td>{inquiry.created_at ? new Date(inquiry.created_at).toLocaleDateString() : '-'}</td>
                                                    <td>
                                                        <button
                                                            className="btn btn-sm btn-info"
                                                            style={{
                                                                backgroundColor: '#17a2b8',
                                                                color: '#fff',
                                                                border: 'none',
                                                                borderRadius: '4px',
                                                                padding: '5px 15px'
                                                            }}
                                                            onClick={() => viewInquiryDetails(inquiry)}
                                                            data-bs-toggle="modal"
                                                            data-bs-target="#viewInquiryModal"
                                                        >
                                                            View
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                ) : (
                                    <div className="data-not-found text-center py-5">
                                        <h2 className="bounce">Data Not Found</h2>
                                        <p className="fade-in">Sorry, no inquiries found.</p>
                                    </div>
                                )}
                            </div>

                            {totalPage > 1 && (
                                <div style={{ justifyContent: 'center', alignItems: 'center', display: 'flex', padding: '15px 0' }}>
                                    <BasicPagination count={totalPage} onChange={(e) => getInquiries(e)} />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {/* View Inquiry Details Modal */}
            <div className="modal fade" id="viewInquiryModal" tabIndex="-1" aria-labelledby="viewInquiryModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header" style={{ backgroundColor: '#008c93', color: '#fff' }}>
                            <h5 className="modal-title" id="viewInquiryModalLabel">Inquiry Details</h5>
                            <button type="button" className="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            {selectedInquiry ? (
                                <div className="row">
                                    <div className="col-md-6 mb-3">
                                        <div className="card h-100">
                                            <div className="card-header bg-light">
                                                <strong>Contact Information</strong>
                                            </div>
                                            <div className="card-body">
                                                <p><strong>Name:</strong> {selectedInquiry.full_name || '-'}</p>
                                                <p><strong>Mobile:</strong> {selectedInquiry.mobile_no || '-'}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <div className="card h-100">
                                            <div className="card-header bg-light">
                                                <strong>Trip Details</strong>
                                            </div>
                                            <div className="card-body">
                                                <p><strong>Trip Location:</strong> {selectedInquiry.trip_location || '-'}</p>
                                                <p><strong>Trip Type:</strong> {getTripTypeBadge(selectedInquiry.trip_type)}</p>
                                                <p><strong>Travel From:</strong> {selectedInquiry.travel_from || '-'}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 mb-3">
                                        <div className="card">
                                            <div className="card-header bg-light">
                                                <strong>Traveller Details</strong>
                                            </div>
                                            <div className="card-body">
                                                <div className="row">
                                                    <div className="col-md-3">
                                                        <p><strong>Total Travellers:</strong> {selectedInquiry.travellers || '-'}</p>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <p><strong>Children:</strong> {selectedInquiry.children_count ?? '-'}</p>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <p><strong>Seniors:</strong> {selectedInquiry.senior_count ?? '-'}</p>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <p><strong>Budget:</strong> {selectedInquiry.budget ? `₹${selectedInquiry.budget}` : '-'}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <div className="card h-100">
                                            <div className="card-header bg-light">
                                                <strong>Additional Info</strong>
                                            </div>
                                            <div className="card-body">
                                                <p><strong>Travel Medium:</strong> {selectedInquiry.travel_medium || '-'}</p>
                                                <p><strong>Time in Hand:</strong> {selectedInquiry.time_hand || '-'}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <div className="card h-100">
                                            <div className="card-header bg-light">
                                                <strong>Inquiry Date</strong>
                                            </div>
                                            <div className="card-body">
                                                <p><strong>Created:</strong> {selectedInquiry.created_at ? new Date(selectedInquiry.created_at).toLocaleString() : '-'}</p>
                                                <p><strong>Updated:</strong> {selectedInquiry.updated_at ? new Date(selectedInquiry.updated_at).toLocaleString() : '-'}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <p className="text-center">No inquiry selected</p>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Inquiries

